import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { getRecordingStatus } from '../../../Slice';
import { Emoji } from './Emoji';
import './emoji.scss';

const EmojiButton = ({ insertEmoji }) => {
   const [showEmojiPicker, setShowEmojiPicker] = useState(false);
   const [pickerPosition, setPickerPosition] = useState('bottom'); // or 'top'
   const containerRef = useRef(null);

   const handleTogglePicker = e => {
      e.stopPropagation(); // prevent bubbling up
      if (getRecordingStatus()) return;
      if (!showEmojiPicker && containerRef.current) {
         const rect = containerRef.current.getBoundingClientRect();
         const pickerHeight = 250;
         const spaceBelow = window.innerHeight - rect.bottom;
         const spaceAbove = rect.top;

         if (spaceBelow < pickerHeight && spaceAbove > pickerHeight) {
            setPickerPosition('top');
         } else {
            setPickerPosition('bottom');
         }
      }
      setShowEmojiPicker(prev => !prev);
   };

   useEffect(() => {
      const handleDocumentMouseDown = event => {
         if (!containerRef.current) return;
         if (!containerRef.current.contains(event.target)) {
            setShowEmojiPicker(false);
         }
      };

      document.addEventListener('mousedown', handleDocumentMouseDown, true);
      return () => document.removeEventListener('mousedown', handleDocumentMouseDown, true);
   }, []);

   return (
      <div className="emoji-wrapper" ref={containerRef}>
         <button className="emoji-icon" aria-label="Emoji picker" onClick={handleTogglePicker}>
            <i className="em em-slightly_smiling_face" data-tag="toggle-emojis-popup"></i>
         </button>

         {showEmojiPicker && (
            <div className={`emoji-picker-container ${pickerPosition}`}>
               <Emoji
                  emojiState={showEmojiPicker}
                  onEmojiClick={emoji => {
                     insertEmoji?.(emoji);
                  }}
                  handleCloseEmojiClick={() => setShowEmojiPicker(false)}
               />
            </div>
         )}
      </div>
   );
};

export default EmojiButton;

EmojiButton.propTypes = {
   insertEmoji: PropTypes.func,
};
